import { motion } from "framer-motion";
import { LuBadgeCheck, LuSparkles } from "react-icons/lu";
import { useLang } from "../i18n";
import { customersContent } from "../data/content";
import "./Customers.css";

/**
 * Social-proof band placed between Hero and About. Shows the city of
 * Helsingborg as our first license customer with a generous logo card and a
 * short bilingual caption.
 */
export default function Customers() {
  const { t } = useLang();

  return (
    <section
      id="customers"
      className="customers"
      aria-label={t(customersContent.eyebrow)}
    >
      <div className="container customers-grid">
        <motion.div
          className="customers-copy"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.5 }}
        >
          <span className="section-eyebrow">
            <LuSparkles size={14} aria-hidden />
            {t(customersContent.eyebrow)}
          </span>
          <h2 className="section-heading customers-title">
            {t(customersContent.title)}
          </h2>
          <p className="section-kicker">{t(customersContent.body)}</p>
          <div className="customers-badge">
            <LuBadgeCheck size={16} aria-hidden />
            <span>{t(customersContent.badge)}</span>
          </div>
        </motion.div>

        <motion.div
          className="customers-logos"
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.55 }}
          aria-hidden="false"
        >
          {customersContent.customers.map((c) => (
            <figure key={c.name} className="customer-logo-card">
              <img src={c.logo} alt={t(c.alt)} loading="lazy" />
              <figcaption>{c.name}</figcaption>
            </figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
